import { get } from "./basic";
import { camelize } from "./format";
import { isFunction } from "./validate";
import locale from "../locale";

function createTranslate(name) {
  var prefix = camelize(name) + ".";
  return function (path) {
    var messages = locale.messages();
    var message = get(messages, prefix + path) || get(messages, path);

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return isFunction(message) ? message.apply(void 0, args) : message;
  };
}

function genBem(name, mods) {
  if (!mods) {
    return "";
  }

  if (typeof mods === "string") {
    return " ".concat(name, "--").concat(mods);
  }

  if (Array.isArray(mods)) {
    return mods.reduce(function (ret, item) {
      return ret + genBem(name, item);
    }, "");
  }

  return Object.keys(mods).reduce(function (ret, key) {
    return ret + (mods[key] ? genBem(name, key) : "");
  }, "");
}

function createBEM(name) {
  return function (el, mods) {
    if (el && typeof el !== "string") {
      mods = el;
      el = "";
    }

    el = el ? "".concat(name, "__").concat(el) : name;
    return "".concat(el).concat(genBem(el, mods));
  };
}

function createNamespace(name) {
  var prefixedName = "van-".concat(name);
  return [prefixedName, createBEM(prefixedName), createTranslate(prefixedName)];
}

export { createBEM, createNamespace, createTranslate };